import { Button } from '@/components/ui/button';
import { Pencil, Check, X } from 'lucide-react';
import { UseEntityFormReturn } from '@/hooks/useEntityForm';
import { FieldValues } from 'react-hook-form';

interface EntityFormHeaderActionsProps<T extends FieldValues> {
  entityForm: UseEntityFormReturn<T>;
  formId: string;
  /** Changes kept outside the form (e.g. extra controls) that should enable submit */
  isDirty?: boolean;
  /** Also called when editing is cancelled, to reset state kept outside the form */
  onCancel?: () => void;
}

export function EntityFormHeaderActions<T extends FieldValues>({
  entityForm,
  formId,
  isDirty = false,
  onCancel,
}: EntityFormHeaderActionsProps<T>) {
  if (entityForm.formMode === 'loading') {
    return null;
  }

  return (
    <>
      {entityForm.formMode === 'view' ? (
        <Button
          variant="ghost"
          size="sm"
          onClick={() => entityForm.setFormMode('edit')}
        >
          <Pencil className="h-4 w-4" />
          Edit
        </Button>
      ) : (
        <>
          <Button
            variant="ghost"
            size="sm"
            onClick={() => {
              entityForm.form.reset();
              onCancel?.();
              entityForm.setFormMode('view');
            }}
          >
            <X className="h-4 w-4" />
            Cancel
          </Button>
          <Button
            type="submit"
            form={formId}
            variant="default"
            size="sm"
            disabled={
              !(entityForm.form.formState.isDirty || isDirty) ||
              entityForm.form.formState.isSubmitting
            }
          >
            <Check className="h-4 w-4" />
            Submit
          </Button>
        </>
      )}
    </>
  );
}
